<template>
  <div class="DefaultSnackbarComponentWrapper">
    <div class="visual">
      <img v-if="picture" class="picture" :src="picture" />
      <i v-else-if="icon" class="icon" :class="icon" />
    </div>
    <div class="content">
      <span v-if="title" class="title preWrap" v-html="title" />
      <span v-if="text" class="text preWrap" v-html="text" />
      <nuxt-link
        v-if="link"
        class="link"
        :to="{ path: '/' + link, query }"
        @click.native="emitUserEvent"
      >
        {{ $t("shared.snackbar." + link) }}
      </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    picture: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    link: {
      type: String,
      required: false,
    },
    query: {
      type: Object,
      required: false,
    },
  },
  methods: {
    emitUserEvent: function () {
      this.$emit("use")
    },
  },
}
</script>

<style scoped src="./defaultTemplate.css"></style>
<style scoped src="./defaultTemplate720.css"></style>
